import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateFind = ({ height = 297, width = 297, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 297 297" {...props}>
    <path
      d="M268.333,166.337c-0.002-17.698-3.965-35.172-11.598-51.139c-7.633-15.968-18.743-30.025-32.515-41.14c-13.772-11.116-29.857-19.008-47.076-23.098c-17.22-4.091-35.136-4.275-52.436-0.541c-17.299,3.734-33.544,11.293-47.543,22.122C63.167,83.369,51.769,97.194,43.808,113c-7.961,15.807-12.283,33.195-12.65,50.89c-0.367,17.694,3.231,35.246,10.53,51.369h216.089C264.749,199.893,268.348,183.211,268.333,166.337z"
      fill="#F5F4F4"
    />
    <path
      d="M32.615,215.258h231.27"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.272,215.258h7.413"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M269.815,215.258h7.413"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M266.387,239.748c0,3.048-48.038,5.791-107.735,5.791c-59.697,0-107.691-2.591-107.691-5.791s48.037-5.791,107.691-5.791C218.306,233.957,266.387,236.7,266.387,239.748z"
      fill="#F5F4F4"
    />
    <path d="M137.232,206.383h26.409v15.847h-26.409V206.383z" fill="#FFFFFF" />
    <path
      d="M137.232,206.383h26.409v15.847h-26.409V206.383z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.771,232.793h-68.666c0-1.388,0.273-2.763,0.804-4.045c0.532-1.283,1.31-2.448,2.292-3.429c0.981-0.982,2.147-1.761,3.429-2.292c1.282-0.531,2.657-0.804,4.045-0.804h47.539c2.801,0.003,5.486,1.118,7.466,3.1C183.659,227.305,184.771,229.992,184.771,232.793L184.771,232.793z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M232.31,98.098c0-1.734-0.341-3.452-1.004-5.054c-0.664-1.602-1.636-3.058-2.863-4.285c-1.226-1.227-2.682-2.199-4.284-2.863c-1.602-0.664-3.319-1.005-5.054-1.005H81.77c-1.734,0-3.452,0.342-5.054,1.005c-1.602,0.664-3.058,1.637-4.284,2.863c-1.226,1.226-2.199,2.682-2.862,4.285c-0.663,1.602-1.005,3.32-1.004,5.054v87.156H232.31V98.098z"
      fill="#E6FFF7"
    />
    <path
      d="M232.31,98.098c0-1.734-0.341-3.452-1.004-5.054c-0.664-1.602-1.636-3.058-2.863-4.285c-1.226-1.227-2.682-2.199-4.284-2.863c-1.602-0.664-3.319-1.005-5.054-1.005H81.77c-1.734,0-3.452,0.342-5.054,1.005c-1.602,0.664-3.058,1.637-4.284,2.863c-1.226,1.226-2.199,2.682-2.862,4.285c-0.663,1.602-1.005,3.32-1.004,5.054v87.156H232.31V98.098z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M219.105,206.381c1.734,0,3.451-0.342,5.053-1.005c1.603-0.664,3.058-1.636,4.284-2.863c1.227-1.226,2.199-2.682,2.863-4.284c0.663-1.602,1.005-3.319,1.005-5.053v-7.922H68.566v7.922c0,3.502,1.391,6.861,3.868,9.337c2.476,2.477,5.835,3.868,9.337,3.868H219.105z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.309,195.818c0,0.83,0.33,1.626,0.917,2.213c0.587,0.588,1.383,0.917,2.214,0.917c0.83,0,1.626-0.329,2.213-0.917c0.587-0.587,0.917-1.383,0.917-2.213c0-0.83-0.33-1.627-0.917-2.214c-0.587-0.587-1.383-0.916-2.213-0.916c-0.831,0-1.627,0.329-2.214,0.916C147.639,194.191,147.309,194.988,147.309,195.818z"
      fill="#622C6A"
    />
    <path
      d="M84.437,97.289h132.001v18.547H84.437V97.289z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M216.438,185.254h-37.131v-56.009c0-0.718,0.285-1.408,0.793-1.916c0.509-0.508,1.198-0.794,1.917-0.794h31.711c0.719,0,1.408,0.286,1.916,0.794c0.509,0.508,0.794,1.198,0.794,1.916V185.254z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.437,126.535h82.516v18.547H84.437V126.535z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.475,155.777h34.481v18.547h-34.481V155.777z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.437,155.777h34.481v18.547H84.437V155.777z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,161.832c0-1.105,0.895-2,2-2h33.804c1.104,0,2,0.895,2,2v65.307c0,1.104-0.896,2-2,2H56.558c-1.105,0-2-0.896-2-2V161.832z"
      fill="#FFFFFF"
      stroke="#4550E5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,161.832c0-1.105,0.895-2,2-2h33.804c1.104,0,2,0.895,2,2v65.307c0,1.104-0.896,2-2,2H56.558c-1.105,0-2-0.896-2-2V161.832z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M54.558,167.707h37.804v53.554H54.558V167.707z" fill="#E6FBFF" />
    <path
      d="M84.178,178.526c0,0.496-0.097,0.986-0.286,1.444c-0.189,0.458-0.467,0.874-0.818,1.224c-0.35,0.35-0.766,0.628-1.224,0.818c-0.458,0.189-0.948,0.286-1.444,0.286H66.512c-0.981-0.028-1.914-0.437-2.598-1.141s-1.068-1.647-1.068-2.629s0.383-1.925,1.068-2.629s1.617-1.114,2.598-1.141h13.894c0.495-0.001,0.985,0.097,1.443,0.286c0.457,0.189,0.873,0.467,1.224,0.817c0.35,0.35,0.628,0.765,0.818,1.222C84.08,177.541,84.178,178.031,84.178,178.526z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.744,190.715h21.434v23.263H62.744V190.715z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,167.707h37.804v53.554H54.558V167.707z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.325,136.352c0-1.105,0.896-2,2-2h71.368c1.104,0,2,0.895,2,2v91.953c0,1.104-0.896,2-2,2h-71.368c-1.104,0-2-0.896-2-2V136.352z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.149,146.645h57.722v71.37h-57.722V146.645z"
      fill="#FFF8D9"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,155.398h40.742v12.803h-40.742V155.398z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M233.297,175.926h12.083v33.332h-12.083V175.926z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,175.926h20.372v12.803h-20.372V175.926z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,196.457h20.372v12.803h-20.372V196.457z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.26,100h0.81c0.11,0,0.2,0.09,0.2,0.2v0.5c0,0.166-0.134,0.3-0.3,0.3h-0.71V100z"
      fill="#622C6A"
    />
    <path
      d="M237.299,173.641l9.283-7.319l8.535,10.827l-9.283,7.318L237.299,173.641z"
      fill="#FFFFFF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.28"
    />
    <path
      d="M272.469,197.103c1.346,1.636,1.995,3.69,1.802,5.71c-0.192,2.02-1.21,3.84-2.828,5.061c-1.618,1.22-3.705,1.74-5.801,1.445c-2.096-0.294-4.03-1.379-5.376-3.015l-15.224-18.514c-0.336-0.409-0.498-0.923-0.45-1.428c0.048-0.505,0.302-0.96,0.707-1.265l9.151-6.9c0.405-0.305,0.927-0.435,1.451-0.361c0.524,0.073,1.007,0.344,1.344,0.753L272.469,197.103z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.28"
    />
    <path
      d="M187.783,122.283c-2.433,4.215-4.013,8.868-4.648,13.693c-0.635,4.826-0.314,9.729,0.946,14.43c1.26,4.702,3.433,9.109,6.396,12.97c2.963,3.861,6.657,7.101,10.872,9.535c4.215,2.433,8.868,4.013,13.694,4.648c4.825,0.636,9.729,0.314,14.43-0.945c4.701-1.26,9.108-3.434,12.97-6.396c3.861-2.963,7.101-6.658,9.535-10.873c2.433-4.215,4.013-8.868,4.648-13.694c0.635-4.825,0.314-9.728-0.946-14.43c-1.26-4.701-3.433-9.108-6.396-12.969c-2.963-3.862-6.657-7.102-10.872-9.535c-4.215-2.434-8.868-4.013-13.694-4.649c-4.825-0.635-9.729-0.313-14.43,0.946c-4.701,1.26-9.108,3.433-12.97,6.396C193.457,114.373,190.217,118.068,187.783,122.283L187.783,122.283z"
      fill="#FFFFFF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.28"
    />
    <path
      d="M191.159,130.32c-2.791,7.573-2.46,15.944,0.921,23.272c3.381,7.328,9.533,13.012,17.105,15.803c7.572,2.79,15.942,2.458,23.269-0.924c7.327-3.382,13.012-9.536,15.803-17.11c2.79-7.573,2.459-15.944-0.921-23.272c-3.381-7.328-9.534-13.012-17.105-15.803c-7.572-2.79-15.942-2.457-23.269,0.924C199.634,116.592,193.95,122.747,191.159,130.32L191.159,130.32z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.28"
    />
  </SvgIcon>
);
